import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-card',
  standalone: true,
  imports: [],
  templateUrl: './ui-card.component.html',
  styleUrl: './ui-card.component.less'
})
export class UiCardComponent {

}
